import { HttpService } from "services";

import { UploadDocsFunction } from "types/functions";
import { AuthorizationLevel } from "types/http";
import { generateQueryString } from "utils";

/**
 * Upload documents related to a given listing
 *
 * @throws {HttpServiceException}
 */
export const uploadDocs: UploadDocsFunction = async (
  ...args: Parameters<UploadDocsFunction>
) => {
  try {
    const { listingId, isTitle, files } = args[0];
    const url = `/document/upload${generateQueryString({ listingId: listingId || undefined, type: isTitle ? 'title' : 'inspection'})}`
    
    const formData = new FormData();
    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documents', files[i])
      }
    }
    await HttpService.fetch(
      url,
      {
        requestConfig: {
          method: "POST",
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return true;
  } catch (error) {
    throw error;
  }
};
